var _style, _circle, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0_male{stroke-width:22;stroke-miterlimit:10;}\r\n\t.st1_male{stroke-width:22;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0_male",
    cx: 150,
    cy: 166.5,
    r: 83.7
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1_male",
    x1: 210.2,
    y1: 108.3,
    x2: 276.7,
    y2: 41.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1_male",
    x1: 276.7,
    y1: 102.1,
    x2: 276.7,
    y2: 41.8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st1_male",
    x1: 216.4,
    y1: 41.8,
    x2: 276.7,
    y2: 41.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.033e9c2f94a3faf53b690bc879520bad.svg";
export { ForwardRef as ReactComponent };